// eslint-disable-next-line import/no-extraneous-dependencies
import $ from 'jquery'
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { v4 as uuidv4 } from 'uuid';

const actions = {
  setearTitulo(texto) {
    $('#contenedor_identificativo').html(texto)
  },
  cargarArchivos(data, nombre_archivo, tipo_archivo) {
    const anchor_href = `${tipo_archivo},${data}`
    const exportLinkElement = document.createElement('a')
    exportLinkElement.hidden = true
    exportLinkElement.download = nombre_archivo
    exportLinkElement.href = anchor_href
    document.body.appendChild(exportLinkElement)
    exportLinkElement.click()
    exportLinkElement.remove()
  },
  
  base64ToArrayBuffer(base64) {
    const binaryString = window.atob(base64); // Decodifica la cadena base64
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
  },
 
  generateZip(item) {
    const zip = new JSZip();

    for ( let i = 0; i < item.length; i++) {
      
      const uuid = uuidv4();
      const contenidoPDF = this.base64ToArrayBuffer(item[i]);
     
      zip.file(`derivacion${uuid}.pdf`, contenidoPDF);
    }
    // Añadir archivos al ZIP
    
    //zip.file("archivo2.txt", "Contenido del archivo 2");


   
    zip.generateAsync({ type: "blob" })
      .then((content) => {
        
        saveAs(content, "derivaciones.zip");
      });
  },

  generateZipInformes(item, paciente) {
    const zip = new JSZip();

    // Sanitizar el nombre del paciente
    const sanitizedPaciente = paciente.replace(/[^a-zA-Z0-9-_]/g, "_");

    for (let i = 0; i < item.length; i++) {
        const uuid = uuidv4();
        const contenidoPDF = this.base64ToArrayBuffer(item[i].pdfBase64);

        // Crear nombres de archivo seguros
        zip.file(`${item[i].nameFile}-${sanitizedPaciente}-${uuid}.pdf`, contenidoPDF);
    }

    zip.generateAsync({ type: "blob" })
      .then((content) => {
        saveAs(content, `${sanitizedPaciente}-INFORMES.zip`);
      });
},



  
  bloquearBoton() {
    $('.btn-guardar').prop('disabled', true);
    $('.btn-guardar span').html('<i class="icon-spinner4 text-size-base spinner"></i>&nbsp;Guardando...');
  },
  desbloquearBoton() {
    $('.btn-guardar').prop('disabled', false);
    $('.btn-guardar span').html(' Guardar');
  },
}

export default actions
